import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Storage } from '@ionic/storage'

import { URL_SERVICIOS_LOCALES, NUBE_AWS, URL_SERVICIOS_AWS} from '../../config/url.servicio'


@Injectable()
export class MesasProvider {
  token:string
  urlPrintService:string
  companiasId:number
  constructor(public http: Http, private storage:Storage) {
      this.storage.get('token').then((val) => {
          this.token = val
      });

      this.storage.get('companiasId').then((val) => {
        this.companiasId = val
    });
  }

  guardar(ubicacionesPorSalones: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      // let request = {
      //   name: ubicacionesPorSalones.name,
      //   parameters : {
      //     name : "dataDynamicCrud",
      //     nombreTabla: "mesas",
      //     companiasId: ubicacionesPorSalones.companiasId,
      //     ...ubicacionesPorSalones
      //   }
      let request = {
        name: "GuardarMesasUnicoRecorrido",
        parameters : {
          companiasId: ubicacionesPorSalones.companiasId,
          cantidad: ubicacionesPorSalones.cantidad
        }

      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, request, options);
    } else {
        let url = URL_SERVICIOS_LOCALES
        let headers = new Headers({
          'Content-Type': 'application/json'
      })
        let options = new RequestOptions({
          headers: headers
        })

        return this.http.post(`${url}/query`, ubicacionesPorSalones, options)
          .map((data) => data.json())
    }
  }

  eliminar(numeroMesa:any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let request = {
        name: "eliminarMesas",
        parameters : {
          numeromesa: numeroMesa
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, request, options).map((data) => data.json());
    } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/proceso/eliminarMesas?numeromesa=${numeroMesa}`)
          .map((data) => data.json())
  }
}

eliminarMesasConComandas(numeroMesa:any) {
  if(NUBE_AWS) {
    let url_servicio = URL_SERVICIOS_AWS;
    let request = {
      name: "eliminarMesasConComandas",
      parameters : {
        numeromesa: numeroMesa
      }
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, request, options).map((data) => data.json());
  } else {
    let url = URL_SERVICIOS_LOCALES
    return this.http.get(`${url}/proceso/eliminarMesas?numeromesa=${numeroMesa}`)
        .map((data) => data.json())
}
}


eliminarMesasConComandasPorCompania(companiasId:any,mesa:any) {
  if(NUBE_AWS) {
    let url_servicio = URL_SERVICIOS_AWS;
    let request = {
      name: "eliminarMesaPorCompania",
      parameters : {
        companiasId:companiasId,
        mesa: mesa
      }
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, request, options).map((data) => data.json());
  } else {
    let url = URL_SERVICIOS_LOCALES
    return this.http.get(`${url}/proceso/eliminarMesas?numeromesa=${mesa}`)
        .map((data) => data.json())
}
}

  eliminarTodas() {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let request = {
        name: "eliminarMesasTodas",
        parameters : {
          companiasId: 0
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, request, options).map((data) => data.json())
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + this.token
      })
      let options = new RequestOptions({
        headers: headers
      })

      return this.http.get(`${url}/proceso/eliminarMesasTodas`)
        .map((data) => data.json())
    }
  }

  eliminarMesasTodasPorCompanias(companiasId:any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let request = {
        name: "eliminarMesasTodasPorCompanias",
        parameters : {
          companiasId: companiasId
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, request, options).map((data) => data.json())
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + this.token
      })
      let options = new RequestOptions({
        headers: headers
      })

      return this.http.get(`${url}/proceso/eliminarMesasTodasPorCompanias?companiasId=${companiasId}`)
        .map((data) => data.json())
   }
  }

  buscar() {
    if(NUBE_AWS ) {
      let url = URL_SERVICIOS_AWS
      let data = {
        name: "mesas",
        parameters : {id: 0}
      }
      let headers = new Headers({ 'Content-Type': 'application/json'}) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http
          .post(`${url}/procedure`, data, options).map((data) => data.json())
  } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + this.token
      })
      let options = new RequestOptions({
        headers: headers
      })

      return this.http.get(`${url}/query?name=mesas`)
        .map((data) => data.json())
   }
  }

  buscarMesasPorCompania(companiasId:any) {
    if(NUBE_AWS ) {
      let url = URL_SERVICIOS_AWS
      let data = {
        name: "buscarMesasPorCompaniaTablet",
        parameters : {companiasId: companiasId}
      }
      let headers = new Headers({'Content-Type': 'application/json', 'authorization': 'Bearer ' + this.token}) // ... Set content type to JSON
      // ,  }
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http
          .post(`${url}/procedure`, data, options).map((data) => data.json())
  } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + this.token
      })
      let options = new RequestOptions({
        headers: headers
      })

      return this.http.get(`${url}/query?name=buscarMesasPorCompania&companiasId=${companiasId}`)
        .map((data) => data.json())
  }
}

  buscarUnicas() {
    if(NUBE_AWS ) {
      let url = URL_SERVICIOS_AWS
      let data = {
        name: "buscarMesas",
        parameters : {id: 0}
      }
      let headers = new Headers({ 'Content-Type': 'application/json'}) // ... Set content type to JSON
      // , 'authorization': 'Bearer ' + this.token
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http
          .post(`${url}/procedure`, data, options).map((data) => data.json())
  } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + this.token
      })
      let options = new RequestOptions({
        headers: headers
      })
      return this.http.get(`${url}/proceso/buscarMesas`)
      .map((data) => data.json())
   }
  }

  buscarMesasPorCompaniaUnico(companiasId:any) {
    if(NUBE_AWS) {
      const url =  URL_SERVICIOS_AWS;
      let data = {
        name: "buscarMesasPorCompaniaUnico",
        parameters : {companiasId: companiasId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http
          .post(`${url}/procedure`, data, options)
      .map((data) => data.json())
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + this.token
      })
      let options = new RequestOptions({
        headers: headers
      })

      // return this.http.get(`${url}/query?name=mesas`)
      //   .map((data) => data.json())
      return this.http.get(`${url}/proceso/buscarMesasPorCompaniaUnico?companiasId=${companiasId}`)
      .map((data) => data.json())
    }
  }


  buscarListamesasPorCompania(valor) {
    if(NUBE_AWS ) {
      let url = URL_SERVICIOS_AWS
      let data = {
        name: "buscarListamesasPorCompania",
        parameters : {companiasId: valor}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http
          .post(`${url}/procedure`, data, options).map((data) => data.json())
    } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=buscarListamesasPorCompania&companiasId=${valor}`)
        .map((data) => data.json())
   }
  }
  ActualizarComandasSinPedido(companiasId: any, turnoNuevo: any, numeroPedido: any) {
    if(NUBE_AWS ) {
      let url = URL_SERVICIOS_AWS
      let data = {
        name: "ActualizarComandasSinPedido",
        parameters : {      companiasId,
          turnoNuevo,
          numeroPedido}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http
          .post(`${url}/procedure`, data, options).map((data) => data.json())
    } else {
    const url = URL_SERVICIOS_LOCALES;
    const datos: any = {
      companiasId,
      turnoNuevo,
      numeroPedido
  };
    return this.http.post(`${url}/procesos/ActualizarComandasSinPedido`, datos);
  }
 }
}



// WEBPACK FOOTER //
// ./src/providers/mesas/mesas.ts